import { connect } from "react-redux";
import { Dispatch } from "react";
import actions from "../redux/actions/Index";
import {
  IGetQueryParams,
  ICreateUpdateAccessControlUserNormalizedReq,
} from "../interfaces/Index";
import AccessControlPage from "../components/pages/accessControl/AccessControlPage";

export const mapStateToProps = (state: any, props: any) => {
  return {
    isLoading: state.accessControlUser.isLoading,
    isError: state.accessControlUser.isError,
    error: state.accessControlUser.error,
    isAccessControlUserAdded: state.accessControlUser.isAccessControlUserAdded,
    accessControlUsers: state.accessControlUser.accessControlUsers,
    pagination: state.accessControlUser.pagination,
    isaccessControlUserDetailsNewFetched:
      state.accessControlUser.isaccessControlUserDetailsNewFetched,
    accessControlUserDetailsNew:
      state.accessControlUser.accessControlUserDetailsNew,
    isAccessControlUserUpdated:
      state.accessControlUser.isAccessControlUserUpdated,
    allClientsRoles: state.accessControlUser.allClientsRoles,
    isAllClientsRolesFetched: state.accessControlUser.isAllClientsRolesFetched,
    userInfo: state.userAuth.userInfo,
    isAllFiltersFetched: state.accessControlUser.isAllFiltersFetched,
    filters: state.accessControlUser.filters
  };
};

export const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    fetchAccessControlUsers: (queryPrams?: IGetQueryParams) =>
      dispatch(actions.getAccessControlUsers(queryPrams)),
    clearAccessControlUserLevelDetails: () =>
      dispatch(actions.clearAccessControlUserLevelDetailsAction()),
    getAccessControlUserDetailsNew: (id: string) =>
      dispatch(actions.getAccessControlUserDetailsNewAction(id)),
    getAllRolesAndClients: () => dispatch(actions.getAllRolesAndClients()),
    createAccessControlUserWithClientAndRoles: (
      payload: ICreateUpdateAccessControlUserNormalizedReq
    ) => dispatch(actions.createAccessControlUserWithClientAndRoles(payload)),
    updateAccessControlUserWithClientAndRoles: (
      payload: ICreateUpdateAccessControlUserNormalizedReq
    ) => dispatch(actions.updateAccessControlUserWithClientAndRoles(payload)),
    fetchAllFilters: () => dispatch(actions.fetchAllFilters())
  };
};

const AccessControlContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AccessControlPage);
export default AccessControlContainer;
